var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-center"},[_c('short-transfer-form',{ref:"shortForm",staticClass:"short-form col-12 col-sm-8 col-md-6",attrs:{"in-iframe":""},on:{"submit":_vm.submit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }